import React from 'react';
import { motion } from 'framer-motion';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import { useTheme } from '../../../contexts/ThemeContext';

const HeroSection = () => {
  const { isDarkMode } = useTheme();

  const handleSchedulePickup = () => {
    window.location.href = '/pickup-scheduling';
  };

  const handleCallNow = () => {
    window.location.href = '/contact-us';
  };

  return (
      // <section className={`relative min-h-screen overflow-hidden z-10 ${isDarkMode
    //     ? 'bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900'
    //     : 'bg-gradient-to-br from-blue-50 via-indigo-50 to-blue-100'
    //   }`}>
    //   {/* Additional gradient layers for richness */}
    //   <div className={`absolute inset-0 ${isDarkMode
    //       ? 'bg-gradient-to-tr from-blue-900/20 via-transparent to-slate-800/30'
    //       : 'bg-gradient-to-tr from-blue-100/40 via-transparent to-indigo-50/60'
    //     }`}></div>
    //   {/* Enhanced Background Pattern */}
    //   <div className="absolute inset-0 overflow-hidden">
    //     {/* Large floating orbs with movement */}
    //     <motion.div
    //       className="absolute top-12 left-6 w-52 h-52 bg-primary/12 rounded-full blur-3xl"
    //       animate={{
    //         y: [0, -20, 0],
    //         x: [0, 10, 0],
    //         scale: [1, 1.1, 1]
    //       }}
    //       transition={{
    //         duration: 8,
    //         repeat: Infinity,
    //         ease: "easeInOut"
    //       }}
    //     ></motion.div>

    //     <motion.div
    //       className="absolute bottom-12 right-6 w-64 h-64 bg-accent/18 rounded-full blur-3xl"
    //       animate={{
    //         y: [0, 15, 0],
    //         x: [0, -15, 0],
    //         scale: [1, 0.9, 1]
    //       }}
    //       transition={{
    //         duration: 10,
    //         repeat: Infinity,
    //         ease: "easeInOut",
    //         delay: 2
    //       }}
    //     ></motion.div>

    //     {/* Medium floating elements */}
    //     <motion.div
    //       className="absolute top-1/3 right-1/5 w-40 h-40 bg-primary/10 rounded-full blur-2xl"
    //       animate={{
    //         y: [0, -25, 0],
    //         rotate: [0, 180, 360]
    //       }}
    //       transition={{
    //         duration: 12,
    //         repeat: Infinity,
    //         ease: "linear"
    //       }}
    //     ></motion.div>

    //     <motion.div
    //       className="absolute top-1/2 left-1/5 w-36 h-36 bg-accent/15 rounded-full blur-2xl"
    //       animate={{
    //         y: [0, 20, 0],
    //         x: [0, -10, 0],
    //         rotate: [0, -90, -180]
    //       }}
    //       transition={{
    //         duration: 9,
    //         repeat: Infinity,
    //         ease: "easeInOut",
    //         delay: 1
    //       }}
    //     ></motion.div>

    //     {/* Small animated shapes */}
    //     <motion.div
    //       className="absolute bottom-1/3 left-1/2 w-32 h-32 bg-primary/8 rounded-full blur-xl"
    //       animate={{
    //         scale: [1, 1.3, 1],
    //         opacity: [0.8, 1, 0.8]
    //       }}
    //       transition={{
    //         duration: 6,
    //         repeat: Infinity,
    //         ease: "easeInOut",
    //         delay: 3
    //       }}
    //     ></motion.div>

    //     {/* Geometric floating elements */}
    //     <motion.div
    //       className="absolute top-1/4 right-1/3 w-24 h-24 bg-accent/12 rounded-lg blur-lg"
    //       animate={{
    //         rotate: [0, 45, 90, 135, 180, 225, 270, 315, 360],
    //         y: [0, -15, 0],
    //         scale: [1, 1.2, 1]
    //       }}
    //       transition={{
    //         duration: 15,
    //         repeat: Infinity,
    //         ease: "linear"
    //       }}
    //     ></motion.div>

    //     <motion.div
    //       className="absolute bottom-1/4 left-1/3 w-20 h-20 bg-primary/10 rounded-lg blur-lg"
    //       animate={{
    //         rotate: [360, 0],
    //         x: [0, 20, 0],
    //         y: [0, -10, 0]
    //       }}
    //       transition={{
    //         duration: 8,
    //         repeat: Infinity,
    //         ease: "easeInOut",
    //         delay: 4
    //       }}
    //     ></motion.div>

    //     {/* Additional floating particles */}
    //     <motion.div
    //       className="absolute top-1/6 left-1/3 w-16 h-16 bg-accent/8 rounded-full blur-md"
    //       animate={{
    //         y: [0, -30, 0],
    //         opacity: [0.6, 1, 0.6]
    //       }}
    //       transition={{
    //         duration: 7,
    //         repeat: Infinity,
    //         ease: "easeInOut",
    //         delay: 2.5
    //       }}
    //     ></motion.div>

    //     <motion.div
    //       className="absolute bottom-1/6 right-1/4 w-12 h-12 bg-primary/12 rounded-full blur-md"
    //       animate={{
    //         x: [0, 25, 0],
    //         scale: [1, 1.5, 1]
    //       }}
    //       transition={{
    //         duration: 5,
    //         repeat: Infinity,
    //         ease: "easeInOut",
    //         delay: 1.5
    //       }}
    //     ></motion.div>

    //     {/* Subtle overlay for depth */}
    //     <div className={`absolute inset-0 ${isDarkMode
    //         ? 'bg-gradient-to-br from-transparent via-slate-900/15 to-blue-900/25'
    //         : 'bg-gradient-to-br from-transparent via-white/20 to-blue-50/40'
    //       }`}></div>

    //     {/* Additional gradient overlays for richness */}
    //     <div className={`absolute inset-0 ${isDarkMode
    //         ? 'bg-gradient-to-tl from-transparent via-primary/5 to-transparent'
    //         : 'bg-gradient-to-tl from-transparent via-accent/8 to-transparent'
            <section className="relative min-h-screen overflow-hidden z-10">
            {/* Background Image - same as services-overview hero */}
            <div className="absolute inset-0">
              <Image
                src="/assets/images/servies.jpg"
                alt="Premium laundry facility background"
                className="w-full h-full object-cover opacity-60"
              />
              <div className={`absolute inset-0 ${
                isDarkMode ? 'bg-slate-900/50' : 'bg-white/50'
          }`}></div>
      </div>
      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 sm:pt-20 pb-12 sm:pb-16">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center min-h-[70vh] sm:min-h-[80vh]">
          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="space-y-6 sm:space-y-8"
          >
            {/* Enhanced Brand Badge */}
            <motion.div
              initial={{ opacity: 0, y: 20, scale: 0.9 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              transition={{ delay: 0.2, duration: 0.6 }}
              className="flex justify-center sm:justify-start"
            >
              <div className={`inline-flex items-center space-x-2 sm:space-x-3 px-4 sm:px-6 py-2 sm:py-3 rounded-full text-xs sm:text-sm font-semibold shadow-lg backdrop-blur-sm ${isDarkMode
                  ? 'bg-gradient-to-r from-slate-700/50 to-slate-600/50 text-slate-200 border border-slate-600/30'
                  : 'bg-gradient-to-r from-primary/15 to-accent/15 text-primary border border-primary/20'
                }`}>
                <motion.div
                  animate={{ rotate: [0, 360] }}
                  transition={{ duration: 3, repeat: Infinity, ease: "linear" }}
                >
                  <Icon name="Sparkles" size={16} />
                </motion.div>
                <span className={`${isDarkMode
                    ? 'text-slate-200'
                    : 'bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent'
                  }`}>
                  Premium Laundry Services
                </span>
              </div>
            </motion.div>

            {/* Enhanced Main Heading */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4, duration: 0.8 }}
              className="space-y-4 sm:space-y-6"
            >
              <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold leading-tight text-center sm:text-left">
                <motion.span
                  className={`block sm:inline ${isDarkMode
                      ? 'text-white'
                      : 'bg-gradient-to-r from-foreground via-foreground to-primary bg-clip-text text-transparent'
                    }`}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.6, duration: 0.8 }}
                >
                  Fresh & Clean
                </motion.span>
                <motion.span
                  className="block sm:inline sm:ml-2 bg-gradient-to-r from-primary via-accent to-primary bg-clip-text text-transparent"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.8, duration: 0.8 }}
                >
                  Laundry Care
                </motion.span>
              </h1>
              <motion.p
                className={`text-base sm:text-lg max-w-2xl leading-relaxed font-medium text-center sm:text-left ${isDarkMode ? 'text-slate-300' : 'text-muted-foreground'
                  }`}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 1, duration: 0.8 }}
              >
                Experience premium laundry services with free pickup & delivery.
                <span className="text-primary font-semibold"> Professional care</span> for your clothes,
                <span className="text-accent font-semibold"> convenience</span> for your life.
              </motion.p>
            </motion.div>

            {/* Enhanced CTA Buttons */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 1.2, duration: 0.8 }}
              className="flex flex-row gap-3 sm:gap-6 justify-center sm:justify-start"
            >
              <motion.div
                whileHover={{ scale: 1.05, y: -2 }}
                whileTap={{ scale: 0.98 }}
                transition={{ type: "spring", stiffness: 300, damping: 20 }}
              >
                <Button
                  variant="default"
                  size="lg"
                  iconName="Calendar"
                  iconPosition="left"
                  onClick={handleSchedulePickup}
                  className="bg-gradient-to-r from-primary via-primary/80 to-accent hover:from-accent hover:via-accent/90 hover:to-primary active:from-accent/90 active:via-primary/70 active:to-primary/80 text-white font-semibold px-4 sm:px-8 py-3 sm:py-4 rounded-xl shadow-elevation-3 hover:shadow-elevation-4 hover:scale-105 active:scale-95 transition-all duration-300 border-0 hover:text-white active:text-white flex-1 sm:flex-none"
                >
                  <motion.span
                    animate={{ x: [0, 2, 0] }}
                    transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
                  >
                    Schedule Pickup
                  </motion.span>
                </Button>
              </motion.div>

              {/* <motion.div
                whileHover={{ scale: 1.05, y: -2 }}
                whileTap={{ scale: 0.98 }}
                transition={{ type: "spring", stiffness: 300, damping: 20 }}
              >
                <Button
                  variant="outline"
                  size="lg"
                  iconName="Phone"
                  iconPosition="left"
                  onClick={handleCallNow}
                  className={`bg-gradient-to-r from-transparent to-transparent hover:from-primary/10 hover:to-accent/10 border-2 font-semibold px-4 sm:px-8 py-3 sm:py-4 rounded-xl shadow-elevation-2 hover:shadow-elevation-3 transition-all duration-300 flex-1 sm:flex-none ${isDarkMode
                      ? 'border-slate-400/50 hover:border-slate-300 text-slate-200 hover:text-white'
                      : 'border-primary/30 hover:border-primary/60 text-primary hover:text-primary'
                    }`}
                >
                  <motion.span
                    animate={{ x: [0, -2, 0] }}
                    transition={{ duration: 2, repeat: Infinity, ease: "easeInOut", delay: 1 }}
                  >
                    Call Now
                  </motion.span>
                </Button>
              </motion.div> */}
            </motion.div>

            {/* Enhanced Trust Indicators */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 1.4, duration: 0.6 }}
              className="flex flex-wrap items-center justify-center sm:justify-start gap-4 sm:gap-6 pt-4 sm:pt-6"
            >
              <motion.div
                className={`flex items-center space-x-2 sm:space-x-3 px-3 sm:px-4 py-2 rounded-full ${isDarkMode
                    ? 'bg-slate-700/50 border border-slate-600/30'
                    : 'bg-success/10 border border-success/20'
                  }`}
                whileHover={{ scale: 1.05, y: -2 }}
                transition={{ type: "spring", stiffness: 300, damping: 20 }}
              >
                <motion.div
                  animate={{ scale: [1, 1.1, 1] }}
                  transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
                >
                  <Icon name="Shield" size={18} color="var(--color-success)" />
                </motion.div>
                <span className={`text-sm font-semibold ${isDarkMode ? 'text-slate-200' : 'text-success'
                  }`}>100% Safe</span>
              </motion.div>

              <motion.div
                className={`flex items-center space-x-2 sm:space-x-3 px-3 sm:px-4 py-2 rounded-full ${isDarkMode
                    ? 'bg-slate-700/50 border border-slate-600/30'
                    : 'bg-primary/10 border border-primary/20'
                  }`}
                whileHover={{ scale: 1.05, y: -2 }}
                transition={{ type: "spring", stiffness: 300, damping: 20 }}
              >
                <motion.div
                  animate={{ rotate: [0, 360] }}
                  transition={{ duration: 3, repeat: Infinity, ease: "linear" }}
                >
                  <Icon name="Clock" size={18} color="var(--color-primary)" />
                </motion.div>
                <span className={`text-sm font-semibold ${isDarkMode ? 'text-slate-200' : 'text-primary'
                  }`}>24hr Service</span>
              </motion.div>

              <motion.div
                className={`flex items-center space-x-2 sm:space-x-3 px-3 sm:px-4 py-2 rounded-full ${isDarkMode
                    ? 'bg-slate-700/50 border border-slate-600/30'
                    : 'bg-accent/10 border border-accent/20'
                  }`}
                whileHover={{ scale: 1.05, y: -2 }}
                transition={{ type: "spring", stiffness: 300, damping: 20 }}
              >
                <motion.div
                  animate={{ scale: [1, 1.2, 1] }}
                  transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
                >
                  <Icon name="Star" size={18} color="var(--color-accent)" />
                </motion.div>
                <span className={`text-sm font-semibold ${isDarkMode ? 'text-slate-200' : 'text-accent'
                  }`}>5-Star Rated</span>
              </motion.div>
            </motion.div>
          </motion.div>

          {/* Right Content - Hero Image */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.3, ease: "easeOut" }}
            className="relative z-30"
          >
            <div className="relative">
              {/* Full Background Hero Image */}
              <div className="relative z-40 w-full h-[600px] rounded-2xl overflow-hidden shadow-elevation-3">
                <Image
                  src="/assets/images/Clean Laundry Care.jpg"
                  alt="Modern laundry care with washing machine and clean towels"
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Enhanced Floating Elements with Full Colored Backgrounds */}
              <motion.div
                initial={{ opacity: 0, scale: 0.8, y: 20 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                transition={{ delay: 1, duration: 0.6 }}
                whileHover={{ scale: 1.05, y: -5 }}
                className="absolute top-4 left-4 sm:-top-8 sm:-left-8 z-50 bg-success rounded-2xl p-3 sm:p-5 shadow-elevation-3"
              >
                <div className="flex items-center space-x-2 sm:space-x-4">
                  <motion.div
                    className="w-8 h-8 sm:w-12 sm:h-12 bg-white/20 rounded-xl flex items-center justify-center"
                    animate={{ scale: [1, 1.1, 1] }}
                    transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
                  >
                    <Icon name="CheckCircle" size={16} className="sm:w-6 sm:h-6 text-white" />
                  </motion.div>
                  <div>
                    <p className="text-xs sm:text-sm font-bold text-white">Quality Assured</p>
                    <p className="text-xs text-white/80 font-medium">Premium Care</p>
                  </div>
                </div>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, scale: 0.8, y: 20 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                transition={{ delay: 1.2, duration: 0.6 }}
                whileHover={{ scale: 1.05, y: -5 }}
                className="absolute bottom-4 right-4 sm:-bottom-8 sm:-right-8 z-50 bg-primary rounded-2xl p-3 sm:p-5 shadow-elevation-3"
              >
                <div className="flex items-center space-x-2 sm:space-x-4">
                  <motion.div
                    className="w-8 h-8 sm:w-12 sm:h-12 bg-white/20 rounded-xl flex items-center justify-center"
                    animate={{ x: [0, 3, 0] }}
                    transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
                  >
                    <Icon name="Truck" size={16} className="sm:w-6 sm:h-6 text-white" />
                  </motion.div>
                  <div>
                    <p className="text-xs sm:text-sm font-bold text-white">Free Delivery</p>
                    <p className="text-xs text-white/80 font-medium">Same Day</p>
                  </div>
                </div>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;